"use client"

import Link from "next/link"
import type { ComponentProps } from "react"

import { cn } from "@/shared/utils/cn"

import { useKayitFlow } from "../hooks/use-kayit-flow"
import { KayitForm } from "./kayit-form"
import { KayitHazirlaniyor } from "./kayit-hazirlaniyor"
import { KayitKilitli } from "./kayit-kilitli"
import { KayitOtpStep } from "./kayit-otp-step"

export function KayitPage({ className, ...props }: ComponentProps<"div">) {
  const {
    adim,
    isSubmitting,
    hataMesaji,
    kalanDeneme,
    tenantCode,
    durum,
    kurulumUzadi,
    email,
    talepOlustur,
    otpDogrula,
    hataTemizle,
    yenidenBasla,
  } = useKayitFlow()

  return (
    <div className={cn("flex flex-col gap-6", className)} {...props}>
      {adim === "form" && (
        <>
          <KayitForm
            isSubmitting={isSubmitting}
            hataMesaji={hataMesaji}
            onSubmit={talepOlustur}
            onDegisiklik={hataTemizle}
          />
          <p className="text-center text-sm text-muted-foreground">
            Zaten hesabınız var mı?{" "}
            <Link
              href="/login"
              className="font-medium text-foreground underline-offset-4 hover:underline"
            >
              Giriş yapın
            </Link>
          </p>
        </>
      )}

      {adim === "otp" && (
        <KayitOtpStep
          email={email}
          isSubmitting={isSubmitting}
          hataMesaji={hataMesaji}
          kalanDeneme={kalanDeneme}
          onSubmit={otpDogrula}
          onDegisiklik={hataTemizle}
          onYenidenBasla={yenidenBasla}
        />
      )}

      {adim === "hazirlaniyor" && (
        <KayitHazirlaniyor
          durum={durum}
          tenantCode={tenantCode}
          kurulumUzadi={kurulumUzadi}
        />
      )}

      {adim === "kilitli" && (
        <KayitKilitli hataMesaji={hataMesaji} onYenidenBasla={yenidenBasla} />
      )}
    </div>
  )
}
